module.exports = "https://static.wmbcdn.com/uniweb/images/4b123e716dabc98429ca24c120d239b5.svg";